<template>
  <div :class="`${appendClass}`">
    <el-form :ref="meta.ref" :rules="rules" :model="data" v-bind="config.container.attrs" :class="`bo-tab__${showTab}`">
      <el-tabs v-bind="config.tabs.attrs">
        <el-tab-pane v-for="(tab, tabIndex) in config.tab" v-bind="tab.attrs" :key="tabIndex">
          <template v-for="(item, itemIndex) in config.items">
            <el-form-item v-if="
              (tab.attrs.tabId === item.attrs.tabId ||
                config.tab.length === 1) &&
                item.type !== 'el-hidden' &&
                (item.fromModel
                  ? data.hasOwnProperty(item.fromModel)
                    ? data[item.fromModel].hasOwnProperty(item.field)
                    : false
                  : data.hasOwnProperty(item.field))
            " :prop="
              item.fromModel ? item.fromModel + '.' + item.field : item.field
            " v-bind="item.attrs" :key="itemIndex">
              <el-tooltip :disabled="!config.container.attrs.inline" class="item"
                :content="item.attrs.title || item.attrs.placeholder">
                <el-input v-if="item.type === 'el-input' && item.fromModel" v-model="data[item.fromModel][item.field]"
                  @change="change(item)" v-bind="item.attrs" :style="item.attrs.style ? item.attrs.style : null"
                  :class="'bo-input'">
                  <template>
                    <div v-for="(slot,slotIndex) in item.slots" :slot="slot.attrs.slot" :key="slotIndex">
                      <el-button
                        v-if="(slot.attrs.label != undefined || slot.type !== 'template')&&slot.type === 'el-button'"
                        :icon="slot.attrs.icon" @click="slotClick(slot)"></el-button>
                      <div
                        v-if="(slot.attrs.label != undefined || slot.type !== 'template')&&slot.attrs.label != undefined">
                        {{ slot.attrs.label }}
                      </div>
                    </div>
                  </template>
                </el-input>
                <el-input v-else-if="item.type === 'el-input'" v-model="data[item.field]" @change="change(item)"
                  v-bind="item.attrs" :style="item.attrs.style ? item.attrs.style : null" :class="'bo-input'">
                  <template>
                    <div v-for="(slot,slotIndex) in item.slots" :slot="slot.attrs.slot" :key="slotIndex">
                      <el-button
                        v-if="( slot.attrs.label != undefined || slot.type !== 'template')&&slot.type === 'el-button'"
                        :icon="slot.attrs.icon" @click="slotClick(slot)">
                      </el-button>
                      <div
                        v-if="( slot.attrs.label != undefined || slot.type !== 'template')&&slot.attrs.label != undefined">
                        {{ slot.attrs.label }}
                      </div>
                    </div>
                  </template>
                </el-input>
                <el-select v-else-if="item.type === 'el-select' && item.fromModel"
                  v-model="data[item.fromModel][item.field]" @change="change(item)" v-bind="item.attrs"
                  :style="item.attrs.style ? item.attrs.style : null">
                  <el-option v-for="option in dim[item.field]" :key="option.value" :label="option.name"
                    :value="option.value">
                  </el-option>
                </el-select>
                <el-select v-else-if="item.type === 'el-select'" v-model="data[item.field]" @change="change(item)"
                  v-bind="item.attrs" :style="item.attrs.style ? item.attrs.style : null">
                  <el-option v-for="option in dim[item.field]" :key="option.value" :label="option.name"
                    :value="option.value">
                  </el-option>
                </el-select>
                <el-date-picker v-else-if="item.type === 'el-date-picker' && item.fromModel"
                  v-model="data[item.fromModel][item.field]" @change="change(item)" v-bind="item.attrs"
                  :format="item.attrs.format || 'yyyy-MM-dd'"  :value-format="item.attrs.format || 'yyyy-MM-dd'" :style="item.attrs.style ? item.attrs.style : null">
                </el-date-picker>
                <el-date-picker v-else-if="item.type === 'el-date-picker'" v-model="data[item.field]"
                  @change="change(item, data[item.field])" v-bind="item.attrs"
                  :format="item.attrs.format || 'yyyy-MM-dd'"  :value-format="item.attrs.format || 'yyyy-MM-dd'" :style="item.attrs.style ? item.attrs.style : null">
                </el-date-picker>
                <el-switch v-else-if="item.type === 'el-switch' && item.fromModel"
                  v-model="data[item.fromModel][item.field]" @change="change(item)" v-bind="item.attrs">
                </el-switch>
                <el-switch v-else-if="item.type === 'el-switch'" v-model="data[item.field]" @change="change(item)"
                  v-bind="item.attrs">
                </el-switch>
                <el-color-picker v-else-if="item.type === 'el-color-picker' && item.fromModel"
                  v-model="data[item.fromModel][item.field]" @change="change(item)" v-bind="item.attrs">
                </el-color-picker>
                <el-color-picker v-else-if="item.type === 'el-color-picker'" v-model="data[item.field]"
                  @change="change(item)" v-bind="item.attrs">
                </el-color-picker>
                <bo-select-tree v-else-if="item.type === 'bo-tree-select' && item.fromModel"
                  @node-click="handleNodeClick" @check="handleNodeCheck" @select-clear="handleTreeClear"
                  @input="handleTreeInput" v-model="data[item.fromModel][item.field]" :field-item="item" :select-params="{
                  multiple: item.attrs.multiple,
                  placeholder: item.attrs.placeholder || item.attrs.title
                }" :tree-params="{
                  defaultExpandAll: item.attrs.defaultExpandAll,
                  filterable: item.attrs.filterable,
                  checkStrictly: true,
                  props: defaultProps
                }" :tree-data="handleTree(dim[item.field])" />
                <bo-select-tree v-else-if="item.type === 'bo-tree-select'" @node-click="handleNodeClick"
                  @check="handleNodeCheck" @select-clear="handleTreeClear" @input="handleTreeInput"
                  v-model="data[item.field]" :field-item="item" :select-params="{
                  multiple: item.attrs.multiple,
                  placeholder: item.attrs.placeholder || item.attrs.title
                }" :tree-params="{
                  defaultExpandAll: item.attrs.defaultExpandAll || true,
                  filterable: item.attrs.filterable,
                  checkStrictly: true,
                  props: defaultProps
                }" :tree-data="handleTree(dim[item.field])" />
                <el-radio-group v-else-if="item.type === 'el-radio-group' && item.fromModel"
                  v-model="data[item.fromModel][item.field]" @change="change(item)" v-bind="item.attrs">
                  >
                  <el-radio v-for="(option,index) in dim[item.field]" :label="option.value" :key="index">
                    {{ option.name }}
                  </el-radio>
                </el-radio-group>
                <el-radio-group v-else-if="item.type === 'el-radio-group'" v-model="data[item.field]"
                  @change="change(item)" v-bind="item.attrs">
                  >
                  <el-radio v-for="(option,index) in dim[item.field]" :label="option.value" :key="index">
                    {{ option.name }}
                  </el-radio>
                </el-radio-group>
                <bo-upload v-else-if="item.type === 'bo-upload' && item.fromModel"
                  v-model="data[item.fromModel][item.field]" :action="props.upload" @change="change" v-bind="item.attrs"
                  :item="item">
                </bo-upload>
                <bo-upload v-else-if="item.type === 'bo-upload'" v-model="data[item.field]" :fieldItem="item"
                  @change="change" :action="props.upload" v-bind="item.attrs" :item="item">
                </bo-upload>
                <bo-editor v-else-if="item.type === 'bo-editor' && item.fromModel"
                  v-model="data[item.fromModel][item.field]" @change="change" v-bind="item.attrs" :item="item">
                </bo-editor>
                <bo-editor v-else-if="item.type === 'bo-editor'" v-model="data[item.field]" @change="change"
                  v-bind="item.attrs" :item="item">
                </bo-editor>
                <bo-map v-else-if="item.type === 'bo-map'" v-model="data" :item="item" @change="changeMap">
                </bo-map>
                <bo-look-up v-else-if="item.type === 'bo-look-up'" v-model="data" :item="item" @change="change"
                  :meta-module="item.serveAttrs.metaModule" :meta-field="item.serveAttrs.metaField">
                </bo-look-up>
                <bo-form-child v-else-if="item.type === 'bo-child'" v-model="data[item.field]" @change="change"
                  @change-form-field="changeFormField" :meta-module="item.serveAttrs.metaModule"
                  :meta-field="item.serveAttrs.metaField" :bridge-item="item" :dim="dim" :props="props"
                  :container="config.container">
                </bo-form-child>
                <div v-else-if="item.type === 'el-label' && item.fromModel" v-bind="item.attrs">
                  {{ data[item.fromModel][item.field] }}
                </div>
                <div v-else-if="item.type === 'el-label'" v-bind="item.attrs">
                  {{ data[item.field] }}
                </div>
                <el-button v-else-if="item.type === 'el-button'" @click="click(data, item)" v-bind="item.attrs">
                  {{ item.attrs.title || item.attrs.placeholder }}
                </el-button>
              </el-tooltip>
            </el-form-item>
          </template>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
  import {
    listConvertTree,
    listConvertMapTree,
    listConvertTreeByRoots
  } from "../utils/tree";

  export default {
    data() {
      return {
        meta: {
          ref: null
        },
        name: "bo-form",
        fields: [],
        defaultProps: {
          children: "children",
          label: "name",
          value: "id"
        }
      };
    },
    components: {
      BoSelectTree: () => import("./bo-select-tree"),
      BoUpload: () => import("./bo-upload"),
      BoEditor: () => import("./bo-editor"),
      BoMap: () => import("./bo-map"),
      BoLookUp: () => import("./bo-look-up"),
      BoFormChild: () => import("./bo-form-child")
    },
    name: "BoForm",
    computed: {
      showTab() {
        return this.config.tab.length === 1 ? 'hidden' : 'display';
      },
      appendClass() {
        return 'bo-form ' + this.props.class || ''
      }
    },
    props: {
      loading: {
        display: true,
        background: null,
        text: null
      },
      props: {
        type: Object,
        ref: {
          type: String
        },
        class: {
          default: "",
          type: String
        },
        upload: {
          type: String
        }
      },
      data: {
        type: Object
      },
      dim: {
        type: Object
      },
      config: {
        type: Object
      },
      rules: {
        type: Object
      },
      metaModule: {
        type: String
      },
      metaField: {
        type: String
      }
    },
    created() {
      this.meta.ref = this.props.ref || "cform";
    },
    methods: {
      changeField(item, fromChild) {
        let tempResult = this.fields.filter(
          temp => temp.field === item.field && temp.fromModel === item.fromModel && temp.fromChild === fromChild
        );
        if (tempResult.length === 0) {
          this.fields.push({
            field: item.field,
            fromModel: item.fromModel,
            fromChild: fromChild
          });
        }
      },
      changeFormField(item, data) {
        //保存变更后的配置项  并提交到表单
        this.changeField(item, true);
        this.$emit("fields", this.fields);
        this.$emit("changeData", item, data);
      },
      change(item, data) {
        //保存变更后的配置项
        this.changeField(item);
        this.$emit("fields", this.fields);
        if (item.attrs.showMethod && item.attrs.showMethod === "image") {
          this.$emit("changeData", item, data.length == 0 ? "" : data[0].url);
        } else if (item.attrs.showMethod && item.attrs.showMethod === "file") {
          this.$emit("changeData", item, data.length == 0 ? "" : data[0].url);
        } else if (item.attrs.showMethod && item.attrs.showMethod === "images") {
          this.$emit("changeData", item, data);
        } else if (item.attrs.showMethod && item.attrs.showMethod === "files") {
          this.$emit("changeData", item, data);
        } else if (
          item.type === "bo-look-up" &&
          item.attrs.showMethod === "array"
        ) {
          this.$emit("changeData", item, data);
        } else if (item.type === "bo-look-up") {
          this.$emit(
            "changeData", {
              field: item.field,
              fromModel: item.fromModel
            },
            data.value
          );
          this.$emit(
            "changeData", {
              field: item.attrs.fieldSn || item.field + "Sn",
              fromModel: item.fromModel
            },
            data.name
          );
        } else if (item.type === "bo-editor") {
          this.$emit("changeData", item, data);
        }
        let param = item.params.change;
        param = (param || "{}").replace(/'/g, '"');
        this.$emit("change", JSON.parse(param), data, item);
      },
      changeMap(item, data) {
        if (item.attrs.showType.includes("lnglat") === true) {
          if (data.lng) {
            this.$emit(
              "changeData", {
                field: item.attrs.lng,
                fromModel: item.fromModel
              },
              data.lng
            );
            this.changeField({
              field: item.attrs.lng,
              fromModel: item.fromModel
            });
          }
          if (data.lat) {
            this.$emit(
              "changeData", {
                field: item.attrs.lat,
                fromModel: item.fromModel
              },
              data.lat
            );
            this.changeField({
              field: item.attrs.lat,
              fromModel: item.fromModel
            });
          }
        }
        if (item.attrs.showType.includes("minmax") === true) {
          if (data.minLng) {
            this.$emit(
              "changeData", {
                field: item.attrs.minLng,
                fromModel: item.fromModel
              },
              data.minLng
            );
            this.changeField({
              field: item.attrs.minLng,
              fromModel: item.fromModel
            });
          }
          if (data.minLat) {
            this.$emit(
              "changeData", {
                field: item.attrs.minLat,
                fromModel: item.fromModel
              },
              data.minLat
            );
            this.changeField({
              field: item.attrs.minLat,
              fromModel: item.fromModel
            });
          }
          if (data.maxLng) {
            this.$emit(
              "changeData", {
                field: item.attrs.maxLng,
                fromModel: item.fromModel
              },
              data.maxLng
            );
            this.changeField({
              field: item.attrs.maxLng,
              fromModel: item.fromModel
            });
          }
          if (data.maxLat) {
            this.$emit(
              "changeData", {
                field: item.attrs.maxLat,
                fromModel: item.fromModel
              },
              data.maxLat
            );
            this.changeField({
              field: item.attrs.maxLat,
              fromModel: item.fromModel
            });
          }
        }
        this.$emit("fields", this.fields);
        let param = item.params.change;
        param = (param || "{}").replace(/'/g, '"');
        this.$emit("change", JSON.parse(param), data, item);
      },
      click(data, item) {
        let param = item.params.click;
        param = (param || "{}").replace(/'/g, '"');
        this.$emit("click", JSON.parse(param), data, item);
      },
      slotClick(item) {},
      resetFields() {
        this.$refs[this.meta.ref].resetFields();
      },
      handleValidate() {
        this.$refs[this.meta.ref].validate(valid => {
          if (valid) {
            this.$emit("validate", true);
          } else {
            this.$emit("validate", false);
            return false;
          }
        });
      },
      handleTree(tempData) {
        let childData = listConvertTreeByRoots(tempData) || [];
        return childData;
      },
      handleNodeClick(data, node, vm) {},
      handleNodeCheck(data, node, vm) {},
      handleTreeClear() {},
      handleTreeInput(ids, item) {
        this.change(item);
      }
    },
    watch: {
      $route: function (to, from) {}
    }
  };
</script>

<style scoped></style>